// Modules
import Common from "./modules/common";
import Animate from "./modules/animate";
import Header from "./modules/header";
import Lightbox from "./modules/lightbox";
import OB from "./modules/outdated-browser";
import WooCommon from "./modules/woo-common";
import QuickCart from "./modules/quick-cart";
import Testimonials from "./modules/testimonials";

// Autoload modules
const modules = [Common, Animate, Header, Lightbox, OB, WooCommon, QuickCart, Testimonials];

modules.forEach((module) => {
  module.init();
});

// import local dependencies
import Router from "./utils/Router";
import templateHome from "./partials/template-home";
import templateContacts from "./partials/template-contacts";
import pageSearch from "./partials/page-search";
import templateCart from "./partials/template-cart";
import templateCheckout from "./partials/template-checkout";
import templateTrade from "./partials/template-trade";
import templateGrain from "./partials/template-grain";
import templateAgro from "./partials/template-agro";
import singleProduct from "./partials/single-product";
import singleCatalogAgro from "./partials/single-catalog-agro";
import templateForms from "./partials/template-forms";
import templateMachinery from "./partials/template-machinery";
import singlePost from "./partials/single-post";
import singleKnowledgeBank from "./partials/single-knowledge-bank";
import templateAgroSoilAnalyse from "./partials/template-agro-soil-analyse";
import singleMachinery from "./partials/single-machinery";
import woocommerceShop from "./partials/archive-product";
import templateMachinerySpareParts from "./partials/template-machinery-spare-parts";
import templateMachineryService from "./partials/template-machinery-service";
import templateCollaboration from "./partials/template-collaboration";

// Populate Router instance with DOM routes
const routes = new Router({
  templateHome,
  templateGrain,
  templateContacts,
  pageSearch,
  templateCart,
  templateCheckout,
  templateCollaboration,
  templateTrade,
  templateAgro,
  templateAgroCatalog: templateAgro,
  taxAgroCategory: templateAgro,
  templateForms,
  singleProduct,
  singleCatalogAgro,
  singleCatalogMachinery: singleProduct,
  singleMachineryNew: singleMachinery,
  singleMachineryOld: singleMachinery,
  singleMachineryRent: singleMachinery,
  templateMachineryCatalogNew: templateMachinery,
  templateMachineryCatalogOld: templateMachinery,
  templateMachineryCatalogRent: templateMachinery,
  templateMachinerySpareParts,
  templateMachineryService,
  singlePost,
  singleKnowledgeBank,
  templateAgroSoilAnalyse,
  woocommerceShop
});

// Load Events
$(document).ready(() => routes.loadEvents());
